import React, { useState } from 'react';
import { 
    Home, 
    Briefcase, 
    Bell, 
    ShoppingCart, 
    ChefHat, 
    Book, 
    MapPin, 
    Heart,
    Search,
    Filter,
    Star,
    Clock,
    QrCode
  } from 'lucide-react';

// 📊 DONNÉES CONFIGURABLES - MODIFIE ICI
const APP_CONFIG = {
  appName: "Meal Events",
  appSubtitle: "SolidApp - Votre plateforme solidaire",
  appDescription: "Emploi • Alimentation responsable • Formation culinaire",
  stats: {
    emplois: { count: 3, label: "nouveaux emplois", subtitle: "Mission locale" },
    invendus: { count: 12, label: "invendus", subtitle: "Disponibles maintenant" },
    cours: { count: 5, label: "cours", subtitle: "Prix solidaires" },
    livre: { label: "Livre de recettes", subtitle: "+ conseils sport" }
  }
};

const EMPLOIS_DATA = [
  {
    id: 1,
    title: "Cuisinier/Cuisinière",
    company: "Meal Events Traiteur", // 👈 MODIFIABLE
    location: "Centre-ville",
    type: "CDI",
    urgent: true
  },
  {
    id: 2,
    title: "Serveur/Serveuse", 
    company: "Meal Events Traiteur", // 👈 AUTRE ENTREPRISE
    location: "Quartier Nord",
    type: "CDD - 2 mois",
    urgent: false
  },
  {
    id: 3,
    title: "Aide de cuisine",
    company: "Cantine Solidaire",
    location: "Mission Locale", 
    type: "Formation rémunérée",
    urgent: false
  }
];

const INVENDUS_DATA = [
  {
    id: 1,
    title: "Quiches lorraines",
    restaurant: "Meal Events Traiteur", // 👈 MODIFIABLE
    price: 3,
    originalPrice: 6,
    quantity: 4,
    expires: "2h"
  },
  {
    id: 2,
    title: "Sandwiches variés",
    restaurant: "Café de la Place", // 👈 AUTRE COMMERÇANT
    price: 2,
    originalPrice: 5,
    quantity: 8,
    expires: "4h"
  },
  {
    id: 3,
    title: "Plats du jour",
    restaurant: "Restaurant L'Étoile",
    price: 8,
    originalPrice: 16,
    quantity: 3,
    expires: "1h"
  }
];

const COURS_DATA = [
  {
    id: 1,
    title: "Cuisine économique et savoureuse",
    chef: "Mwendzao", // 👈 MODIFIABLE
    price: 25,
    solidairePrice: 10,
    duration: "2h",
    level: "Débutant"
  },
  {
    id: 2,
    title: "Batch cooking familial",
    chef: "Mwendzao",
    price: 30,
    solidairePrice: 12,
    duration: "3h", 
    level: "Intermédiaire"
  },
  {
    id: 3,
    title: "Cuisine anti-gaspillage",
    chef: "Mwendzao",
    price: 20,
    solidairePrice: 8,
    duration: "1h30",
    level: "Tous niveaux"
  }
];

export default function TraiteurApp() {
  const [activeTab, setActiveTab] = useState('home');
  const [notifications, setNotifications] = useState(true);

  const TabButton = ({ id, icon: Icon, label, active, onClick, desktop = false }) => (
    <button
      onClick={() => onClick(id)}
      className={`flex ${desktop ? 'flex-row space-x-3 w-full p-4 rounded-xl' : 'flex-col'} items-center ${desktop ? '' : 'p-3 rounded-lg'} transition-all group ${
        active 
          ? `${desktop ? 'bg-black text-white shadow-lg shadow-black/25' : 'bg-black text-white shadow-lg'}`
          : `text-gray-600 hover:text-pink-600 ${desktop ? 'hover:bg-pink-50' : 'hover:bg-gray-100'}`
      }`}
    >
      <Icon size={desktop ? 20 : 24} className={`${active ? '' : 'group-hover:scale-110'} transition-transform`} />
      <span className={`${desktop ? 'text-sm' : 'text-xs mt-1'} font-medium`}>{label}</span>
    </button>
  );

  const JobCard = ({ title, company, location, type, urgent = false }) => (
    <div className={`p-4 rounded-xl border-2 ${urgent ? 'border-orange-200 bg-orange-50' : 'border-gray-200 bg-white'} shadow-sm hover:shadow-md transition-shadow`}>
      {urgent && <span className="inline-block px-2 py-1 bg-orange-100 text-orange-800 text-xs rounded-full mb-2">Urgent</span>}
      <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
      <p className="text-gray-600 text-sm mb-2">{company}</p>
      <div className="flex items-center text-gray-500 text-sm mb-2">
        <MapPin size={14} className="mr-1" />
        {location}
      </div>
                    <span className="inline-block px-2 py-1 bg-pink-100 text-pink-800 text-xs rounded-full">{type}</span>
    </div>
  );

  const InvenduCard = ({ title, restaurant, price, originalPrice, quantity, expires }) => (
    <div className="p-6 rounded-2xl border border-gray-200/50 bg-white/60 backdrop-blur-lg hover:shadow-xl transition-all duration-300 hover:scale-[1.02]">
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-bold text-gray-900 text-lg">{title}</h3>
        <div className="text-right">
          <span className="text-xl font-bold bg-gradient-to-r from-pink-600 to-pink-500 bg-clip-text text-transparent">{price}€</span>
          <span className="text-sm text-gray-500 line-through ml-2">{originalPrice}€</span>
        </div>
      </div>
      <p className="text-gray-600 mb-3">{restaurant}</p>
      <div className="flex justify-between items-center text-sm text-gray-500">
        <span className="bg-pink-100 text-pink-700 px-2 py-1 rounded-full">{quantity} portions</span>
        <div className="flex items-center">
          <Clock size={16} className="mr-1" />
          Expire dans {expires}
        </div>
      </div>
    </div>
  );

  const CourseCard = ({ title, chef, price, solidairePrice, duration, level }) => (
    <div className="p-4 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow">
      <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
      <p className="text-gray-600 text-sm mb-2">avec {chef}</p>
      <div className="flex items-center justify-between mb-2">
        <div>
          <span className="text-lg font-bold text-pink-600">{solidairePrice}€</span>
          <span className="text-sm text-gray-500 line-through ml-1">{price}€</span>
          <span className="text-xs text-pink-600 ml-1">(prix solidaire)</span>
        </div>
        <div className="flex items-center">
          <Star size={14} className="text-yellow-500 mr-1" />
          <span className="text-sm">{level}</span>
        </div>
      </div>
      <span className="inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">{duration}</span>
    </div>
  );

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return (
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-pink-600 via-pink-500 to-pink-400 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-16 translate-x-16"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full translate-y-12 -translate-x-12"></div>
              <div className="relative z-10">
                <div className="flex items-center mb-4">
                  <div className="bg-white/20 p-3 rounded-xl mr-4 backdrop-blur-sm">
                    <ChefHat size={32} className="text-white" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-3xl font-bold">{APP_CONFIG.appName}</h2>
                    <p className="text-pink-100 opacity-90 mt-1">{APP_CONFIG.appSubtitle}</p>
                  </div>
                </div>
                <p className="text-pink-100 text-lg text-center">{APP_CONFIG.appDescription}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="bg-white/60 backdrop-blur-lg p-6 rounded-2xl border border-gray-200/50 text-center hover:shadow-xl hover:scale-105 transition-all duration-300 group">
                <div className="bg-gradient-to-r from-pink-600 to-pink-500 p-3 rounded-xl mx-auto mb-3 w-fit group-hover:scale-110 transition-transform">
                  <Briefcase className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-lg">{APP_CONFIG.stats.emplois.count} {APP_CONFIG.stats.emplois.label}</h3>
                <p className="text-sm text-gray-600">{APP_CONFIG.stats.emplois.subtitle}</p>
              </div>
              <div className="bg-white/60 backdrop-blur-lg p-6 rounded-2xl border border-gray-200/50 text-center hover:shadow-xl hover:scale-105 transition-all duration-300 group">
                <div className="bg-gradient-to-r from-pink-500 to-pink-400 p-3 rounded-xl mx-auto mb-3 w-fit group-hover:scale-110 transition-transform">
                  <ShoppingCart className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-lg">{APP_CONFIG.stats.invendus.count} {APP_CONFIG.stats.invendus.label}</h3>
                <p className="text-sm text-gray-600">{APP_CONFIG.stats.invendus.subtitle}</p>
              </div>
              <div className="bg-white/60 backdrop-blur-lg p-6 rounded-2xl border border-gray-200/50 text-center hover:shadow-xl hover:scale-105 transition-all duration-300 group">
                <div className="bg-gradient-to-r from-pink-600 to-pink-500 p-3 rounded-xl mx-auto mb-3 w-fit group-hover:scale-110 transition-transform">
                  <ChefHat className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-lg">{APP_CONFIG.stats.cours.count} {APP_CONFIG.stats.cours.label}</h3>
                <p className="text-sm text-gray-600">{APP_CONFIG.stats.cours.subtitle}</p>
              </div>
              <div className="bg-white/60 backdrop-blur-lg p-6 rounded-2xl border border-gray-200/50 text-center hover:shadow-xl hover:scale-105 transition-all duration-300 group">
                <div className="bg-gradient-to-r from-pink-500 to-pink-400 p-3 rounded-xl mx-auto mb-3 w-fit group-hover:scale-110 transition-transform">
                  <Book className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-lg">{APP_CONFIG.stats.livre.label}</h3>
                <p className="text-sm text-gray-600">{APP_CONFIG.stats.livre.subtitle}</p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-pink-50 to-pink-100 border-l-4 border-pink-400 p-6 rounded-xl backdrop-blur-sm">
              <div className="flex items-center">
                <div className="bg-pink-500 p-2 rounded-lg mr-3">
                  <Bell className="text-white" size={20} />
                </div>
                <div>
                  <span className="font-semibold text-gray-900">Nouvelle alerte emploi disponible !</span>
                  <p className="text-sm text-gray-600 mt-1">Cuisinier - Restaurant Le Jardin - CDI</p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'jobs':
        return (
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">Offres d'emploi</h2>
              <div className="flex space-x-2">
                <button className="p-2 bg-gray-100 rounded-lg">
                  <Search size={20} />
                </button>
                <button className="p-2 bg-gray-100 rounded-lg">
                  <Filter size={20} />
                </button>
              </div>
            </div>

            <div className="bg-pink-50 border border-pink-200 p-4 rounded-lg">
              <div className="flex items-center justify-between">
                <div>
                  <span className="font-medium">Alertes emploi activées</span>
                  <p className="text-sm text-gray-600">Notifications par email et SMS</p>
                </div>
                <button 
                  onClick={() => setNotifications(!notifications)}
                  className={`p-2 rounded-full ${notifications ? 'bg-pink-600 text-white' : 'bg-gray-200'}`}
                >
                  <Bell size={16} />
                </button>
              </div>
            </div>

            <div className="space-y-4">
              {EMPLOIS_DATA.map(emploi => (
                <JobCard 
                  key={emploi.id}
                  title={emploi.title}
                  company={emploi.company}
                  location={emploi.location}
                  type={emploi.type}
                  urgent={emploi.urgent}
                />
              ))}
            </div>
          </div>
        );

      case 'invendus':
        return (
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">Invendus disponibles</h2>
              <button className="p-2 bg-gray-100 rounded-lg">
                <Bell size={20} />
              </button>
            </div>

            <div className="bg-orange-50 border border-orange-200 p-4 rounded-lg">
              <div className="flex items-center">
                <Bell className="text-orange-600 mr-2" size={20} />
                <span className="font-medium">Alerte invendus activée</span>
              </div>
              <p className="text-sm text-gray-600 mt-1">Vous serez notifié des nouveaux invendus à proximité</p>
            </div>

            <div className="space-y-4">
              {INVENDUS_DATA.map(invendu => (
                <InvenduCard 
                  key={invendu.id}
                  title={invendu.title}
                  restaurant={invendu.restaurant}
                  price={invendu.price}
                  originalPrice={invendu.originalPrice}
                  quantity={invendu.quantity}
                  expires={invendu.expires}
                />
              ))}
            </div>
          </div>
        );

      case 'courses':
        return (
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold">Cours de cuisine</h2>
              <button className="px-4 py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors">
                Réserver
              </button>
            </div>

            <div className="bg-pink-50 border border-pink-200 p-4 rounded-lg">
              <div className="flex items-center">
                <Heart className="text-pink-600 mr-2" size={20} />
                <span className="font-medium">Prix solidaires</span>
              </div>
              <p className="text-sm text-gray-600 mt-1">Tarifs préférentiels pour les bénéficiaires de la mission locale</p>
            </div>

            <div className="space-y-4">
              {COURS_DATA.map(cours => (
                <CourseCard 
                  key={cours.id}
                  title={cours.title}
                  chef={cours.chef}
                  price={cours.price}
                  solidairePrice={cours.solidairePrice}
                  duration={cours.duration}
                  level={cours.level}
                />
              ))}
            </div>
          </div>
        );

      case 'quartier':
        return (
          <div className="space-y-4">
            <h2 className="text-xl font-bold">Services de quartier</h2>
            
            <div className="grid grid-cols-1 gap-4">
              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold">Emploi local</h3>
                  <Briefcase className="text-pink-600" size={24} />
                </div>
                <p className="text-gray-600 text-sm mb-3">Offres d'emploi spécifiques au quartier</p>
                <button className="w-full py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors">
                  Voir les offres (2 nouvelles)
                </button>
              </div>

              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold">Vente invendus</h3>
                  <ShoppingCart className="text-pink-500" size={24} />
                </div>
                <p className="text-gray-600 text-sm mb-3">Points de vente des commerçants locaux</p>
                <button className="w-full py-2 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors">
                  Voir la carte (5 points actifs)
                </button>
              </div>

              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-semibold">Cours de cuisine</h3>
                  <ChefHat className="text-pink-600" size={24} />
                </div>
                <p className="text-gray-600 text-sm mb-3">Ateliers organisés dans le quartier</p>
                <button className="w-full py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors">
                  S'inscrire (3 places libres)
                </button>
              </div>
            </div>
          </div>
        );

      case 'livre':
        return (
          <div className="space-y-4">
            <h2 className="text-xl font-bold">Livre de recettes</h2>
            
            <div className="bg-gradient-to-r from-pink-500 to-pink-600 rounded-xl p-6 text-white text-center">
              <Book size={48} className="mx-auto mb-3" />
              <h3 className="text-xl font-bold mb-2">Cuisiner & Bouger</h3>
              <p className="opacity-90">Recettes équilibrées + conseils sportifs</p>
            </div>

            <div className="bg-white p-4 rounded-xl border border-gray-200">
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-semibold">Scanner un QR code</h3>
                <QrCode size={24} />
              </div>
              <p className="text-gray-600 text-sm mb-3">Scannez le QR code de votre livre pour accéder aux contenus interactifs</p>
              <button className="w-full py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700 transition-colors">
                Ouvrir le scanner
              </button>
            </div>

            <div className="space-y-3">
              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <h3 className="font-semibold mb-2">Exemple : Quiche au fromage</h3>
                <p className="text-gray-600 text-sm mb-2">Une quiche gourmande et économique</p>
                <div className="bg-pink-50 p-3 rounded-lg">
                  <div className="flex items-center">
                    <span className="text-pink-600 font-medium">💪 Pour brûler cette quiche :</span>
                  </div>
                  <p className="text-sm text-gray-700 mt-1">30 min de marche rapide ou 15 min de vélo</p>
                </div>
              </div>

              <div className="bg-white p-4 rounded-xl border border-gray-200">
                <h3 className="font-semibold mb-2">Exemple : Salade composée</h3>
                <p className="text-gray-600 text-sm mb-2">Fraîche et pleine de vitamines</p>
                <div className="bg-pink-50 p-3 rounded-lg">
                  <div className="flex items-center">
                    <span className="text-pink-600 font-medium">✨ Bonus santé :</span>
                  </div>
                  <p className="text-sm text-gray-700 mt-1">5 étirements à faire après le repas</p>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return <div>Page non trouvée</div>;
    }
  };

  return (
    <div className="w-full max-w-md mx-auto lg:max-w-7xl bg-gray-50 min-h-screen relative">
      {/* PWA Meta Tags simulation */}
      <div className="hidden">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="theme-color" content="#c43e71" />
        <link rel="manifest" href="/manifest.json" />
      </div>
      {/* Header */}
      <div className="bg-white/80 backdrop-blur-lg border-b border-gray-200/50 px-4 lg:px-8 py-4 sticky top-0 z-50">
        <div className="flex items-center justify-between max-w-6xl mx-auto">
          <div className="flex items-center">
            <div className="bg-gradient-to-r from-pink-600 to-pink-500 p-2 rounded-xl mr-3">
              <ChefHat className="text-white" size={28} />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-pink-600 to-pink-500 bg-clip-text text-transparent">
                Meal Events Traiteur
              </h1>
              <p className="text-sm text-gray-600 hidden lg:block">Plateforme solidaire</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="relative">
              <Bell size={24} className="text-gray-600 hover:text-pink-600 transition-colors cursor-pointer" />
              <span className="absolute -top-1 -right-1 bg-gradient-to-r from-pink-500 to-pink-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-left animate-pulse">3</span>
            </div>
            <div className="hidden lg:flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-r from-pink-500 to-pink-600 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-semibold">ME</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 lg:px-8 py-6 pb-24 lg:pb-8">
        <div className="max-w-6xl mx-auto">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            {/* Sidebar Navigation - Desktop */}
            <div className="hidden lg:block lg:col-span-3">
              <div className="bg-white/60 backdrop-blur-lg rounded-2xl p-6 border border-gray-200/50 sticky top-24">
                <div className="space-y-3">
                  <TabButton 
                    id="home" 
                    icon={Home} 
                    label="Accueil" 
                    active={activeTab === 'home'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                  <TabButton 
                    id="jobs" 
                    icon={Briefcase} 
                    label="Emploi" 
                    active={activeTab === 'jobs'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                  <TabButton 
                    id="invendus" 
                    icon={ShoppingCart} 
                    label="Invendus" 
                    active={activeTab === 'invendus'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                  <TabButton 
                    id="courses" 
                    icon={ChefHat} 
                    label="Cours" 
                    active={activeTab === 'courses'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                  <TabButton 
                    id="quartier" 
                    icon={MapPin} 
                    label="Quartier" 
                    active={activeTab === 'quartier'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                  <TabButton 
                    id="livre" 
                    icon={Book} 
                    label="Livre" 
                    active={activeTab === 'livre'} 
                    onClick={setActiveTab}
                    desktop={true}
                  />
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="lg:col-span-9">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation - Mobile Only */}
      <div className="fixed bottom-0 left-0 right-0 lg:hidden bg-white/80 backdrop-blur-lg border-t border-gray-200/50 px-4 py-2">
        <div className="flex justify-around max-w-md mx-auto">
          <TabButton 
            id="home" 
            icon={Home} 
            label="Accueil" 
            active={activeTab === 'home'} 
            onClick={setActiveTab} 
          />
          <TabButton 
            id="jobs" 
            icon={Briefcase} 
            label="Emploi" 
            active={activeTab === 'jobs'} 
            onClick={setActiveTab} 
          />
          <TabButton 
            id="invendus" 
            icon={ShoppingCart} 
            label="Invendus" 
            active={activeTab === 'invendus'} 
            onClick={setActiveTab} 
          />
          <TabButton 
            id="courses" 
            icon={ChefHat} 
            label="Cours" 
            active={activeTab === 'courses'} 
            onClick={setActiveTab} 
          />
          <TabButton 
            id="quartier" 
            icon={MapPin} 
            label="Quartier" 
            active={activeTab === 'quartier'} 
            onClick={setActiveTab} 
          />
          <TabButton 
            id="livre" 
            icon={Book} 
            label="Livre" 
            active={activeTab === 'livre'} 
            onClick={setActiveTab} 
          />
        </div>
      </div>
    </div>
    
  );
}